const AppName = 'Prp'

export default AppName
